export const resources_mobile_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/mobile_horizontal/adaptiveBackground.jpg",
            "res/mobile_horizontal/background_utility.png",

            {name: "res/mobile_horizontal/mainbackground.png", rus: true},
            {name: "res/mobile_horizontal/tables/forward.png", rus: true},
            {name: "res/mobile_horizontal/tables/lose.png", rus: true},
            {name: "res/mobile_horizontal/tables/win.png", rus: true},
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/mobile_horizontal/resources.es6
// module id = 112
// module chunks = 0